export default __webpack_public_path__ + "959aea96a884820d9c247e3383bd8599.png";